import React from 'react';

import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import { Calculator,} from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Scan Product Barcode' },
    position: { x: 50, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '2',
    data: { label: 'Add to Cart & Calculate Tax' },
    position: { x: 250, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '3',
    data: { label: 'Choose Payment Method' },
    position: { x: 450, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '4',
    data: { label: 'Process Payment Gateway' },
    position: { x: 650, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '5',
    data: { label: 'Update Inventory Stock' },
    position: { x: 150, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '6',
    data: { label: 'Generate Digital Receipt' },
    position: { x: 350, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '7',
    data: { label: 'Save Transaction to DB' },
    position: { x: 550, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '8',
    data: { label: 'Send Receipt via Email/SMS' },
    position: { x: 250, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '9',
    type: 'output',
    data: { label: 'Sale Complete' },
    position: { x: 450, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e4-6', source: '4', target: '6', animated: true },
  { id: 'e4-7', source: '4', target: '7', animated: true },
  { id: 'e6-8', source: '6', target: '8', animated: true },
  { id: 'e7-8', source: '7', target: '8', animated: true },
  { id: 'e8-9', source: '8', target: '9', animated: true },
];

const ProjectFive = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="Web App Based POS System"
      tagline="A point-of-sale that runs in the browser — no legacy hardware required."
      icon={<Calculator className="w-7 h-7" />}
      context="A retail business was locked into expensive, rigid POS terminals and needed something flexible their staff could run anywhere."
      built="A web-based POS handling transactions, real-time inventory, and reporting — with AI-enhanced workflows layered on top for operational assistance."
      stack={['React', 'Node.js', 'REST APIs', 'Inventory engine']}
      highlights={['Real-time inventory sync', 'Fast checkout flow', 'Runs on any device with a browser']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default ProjectFive;